<script setup lang="ts">
defineProps({
  gfalId: {
    type: String,
    required: true,
  },
});
const userStore = useUserStore();
</script>
<template>
  <div
    class="border-b-2 border-primary-900 px-7 py-2.5 text-left flex items-center gap-2">
    <p class="text-neutral-300">{{ $t("main.storeDetail.ownedBy") }}</p>
    <div class="group">
      <CommonUserCard
        :id="gfalId"
        size="custom"
        custom-class="w-8"
        font-size="text-sm"
        :special-border="userStore.isCurrentUserId(gfalId)"
        :special-text="userStore.isCurrentUserId(gfalId)" />
    </div>
  </div>
</template>
